import classNames from 'classnames';
import React, { useMemo } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Divider, Toggle } from 'rsuite';
import { RootState } from '../../../../../@types/RootState';
import { InputBox } from '../../../../../components';
import { ChannelsConfigSchema } from '../../../../../reducers/reducerIPA/channels';
import containerStyles from '../SetupIPA/SetupIPA.module.scss';
import styles from './SetupIpaChannels.module.scss';
import { SetupIpaChannelsInfoCallout } from './SetupIpaChannelsInfoCallout';

type SetupOfferFormProps = { form: UseFormReturn<ChannelsConfigSchema> };

export const SetupOfferForm = ({ form }: SetupOfferFormProps) => {
  const channels = useSelector((state: RootState) => state.clienteDataReducer?.clienteData?.servicoIpa?.canais);

  const isFarmaClient: boolean = useMemo(() => {
    if (!channels) return false;
    return channels.includes('FARMA');
  }, [channels]);

  return (
    <div className={styles.wrapper}>
      <div>
        <h3 className={containerStyles['section-title']}>Preço oferta</h3>
        <p className={classNames(containerStyles['setup-ipa__header__subtitle'], styles['header-subtitle'])}>
          Habilitar e definir as configurações para a precificação de preços promocionais
        </p>
      </div>

      <div className={styles['toggle-container']}>
        <Controller control={form.control} name="offer.enabled" render={({ field: { value, ...field } }) => <Toggle size="sm" checked={value} {...field} />} />
        <span>
          <h5 className={styles['toggle-container__title']}>Usar o preço de oferta no IPA</h5>
          <p className={styles['toggle-container__subtitle']}>Visualize o preço de oferta vigente do produto diretamente no gerenciador de preços do IPA</p>
        </span>
      </div>

      {!!form.watch('offer.enabled') && (
        <>
          <Divider />
          <div className={styles['checkbox-container']}>
            <Controller
              control={form.control}
              name="offer.allowCreateRule"
              render={({ field: { value, ...field }, fieldState: { error } }) => (
                <InputBox>
                  <InputBox.Check checked={value} {...field} disabled={!isFarmaClient}>
                    <h5 className="font-size-100-regular">Permitir a criação de regras de oferta</h5>
                    <p>Essa opção possibilita a criação de regras específicas para o preço de oferta</p>
                  </InputBox.Check>
                  <InputBox.Error message={error?.message} />
                </InputBox>
              )}
            />

            <Controller
              control={form.control}
              name="offer.allowPriceEdit"
              render={({ field: { value, ...field }, fieldState: { error } }) => (
                <InputBox>
                  <InputBox.Check checked={value} {...field} disabled={!isFarmaClient}>
                    <h5 className="font-size-100-regular">Permitir a edição do preço de oferta diretamente no gerenciador</h5>
                    <p>Possibilita a edição do preço de oferta diretamente na tela de gerenciador de preços.</p>
                  </InputBox.Check>
                  <InputBox.Error message={error?.message} />
                </InputBox>
              )}
            />
          </div>
          <SetupIpaChannelsInfoCallout isFarmaClient={isFarmaClient} />
        </>
      )}
    </div>
  );
};
